export default __webpack_public_path__ + "static/img/qr_code_android_app.89097a2.svg";